// Paginación client-side reutilizable. Muestra "Anterior / Siguiente" y el
// rango actual. Se oculta sola cuando hay una sola página.
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, pageSize, total, onPageChange, testid = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);
  return (
    <div className="flex items-center justify-between gap-3 px-5 py-3 border-t border-[#E1E5F0] bg-[#FAFBFE]" data-testid={testid}>
      <p className="text-[11px] font-bold text-[#6E7591]" data-testid={`${testid}-range`}>
        {from}–{to} de {total}
      </p>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          data-testid={`${testid}-prev`}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg border-2 border-[#E1E5F0] text-xs font-bold text-[#1F2547] hover:border-[#A43790] disabled:opacity-40 disabled:cursor-not-allowed"
        >
          <ChevronLeft size={14} /> Anterior
        </button>
        <span className="text-xs font-extrabold text-[#1F2547]" data-testid={`${testid}-page`}>
          {page} / {totalPages}
        </span>
        <button
          type="button"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages}
          data-testid={`${testid}-next`}
          className="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg border-2 border-[#E1E5F0] text-xs font-bold text-[#1F2547] hover:border-[#A43790] disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Siguiente <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
